export default __webpack_public_path__ + "static/media/biopankki-footer-logos-new.c3d67a64.png";